import { useSelector } from "react-redux";
import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";

export default function CategoryFilter() {
    const categoryListData = useSelector((state) => state.webSetting.categoryListData);
    const [searchParams, setSearchParams] = useSearchParams();
    const [showAllCategories, setShowAllCategories] = useState(false);

    // Parse the "category" query parameter from the URL
    const selectedCategories = searchParams.get('category') ? searchParams.get('category').split('&') : [];

    // Function to handle checkbox clicks
    const handleCategoryChange = (categoryName) => {
        const newCategories = [...selectedCategories];

        if (newCategories.includes(categoryName)) {
            // If the category is already selected, remove it
            const index = newCategories.indexOf(categoryName);
            if (index > -1) {
                newCategories.splice(index, 1);
            }
        } else {
            // If the category is not selected, add it
            newCategories.push(categoryName);
        }

        // Update the query params
        const newParams = new URLSearchParams(searchParams);
        if (newCategories.length > 0) {
            newParams.set('category', newCategories.join('&'));
        } else {
            newParams.delete('category');
        }

        setSearchParams(newParams);
    };

    const toggleShowAllCategories = () => {
        setShowAllCategories(!showAllCategories);
    };

    const categoriesToShow = showAllCategories ? Object.values(categoryListData) : Object.values(categoryListData).slice(0, 3);

    return (
        <div className='category-container'>
            <h2 className='text-lg text-primary font-semibold'>Shop By Category :</h2>
            <hr />
            {categoriesToShow?.map((data, index) => {
                const isChecked = selectedCategories.includes(data.slug); // Check if this category is selected
                return (
                    <div className='mt-2' key={index}>
                        <label className='category-item'>
                            <input
                                className='h-4 text-gray'
                                type="checkbox"
                                name="category1"
                                checked={isChecked} // Set checkbox state based on URL
                                onChange={() => handleCategoryChange(data.slug)} // Handle checkbox click
                            />
                            {data.name}
                        </label>
                    </div>
                );
            })}

            {Object.values(categoryListData).length > 3 && (
                <button
                    className="text-blue hover:text-primary font-semibold mt-2"
                    onClick={toggleShowAllCategories}
                >
                    {showAllCategories ? "Show Less" : "Show More"}
                </button>
            )}
        </div>
    );
}
